export interface PurchaseNotification {
  name: string
  city: string
  pack: 'Pack Base' | 'Megapack Premium'
  minutesAgo: number
}

export const purchaseNotifications: PurchaseNotification[] = [
  { name: 'María G.', city: 'Ciudad de México, MX', pack: 'Megapack Premium', minutesAgo: 3 },
  { name: 'Jorge L.', city: 'Bogotá, CO', pack: 'Pack Base', minutesAgo: 6 },
  { name: 'Silvia R.', city: 'Buenos Aires, AR', pack: 'Megapack Premium', minutesAgo: 8 },
  { name: 'Daniel M.', city: 'Lima, PE', pack: 'Pack Base', minutesAgo: 11 },
  { name: 'Claudia P.', city: 'Santiago, CL', pack: 'Megapack Premium', minutesAgo: 14 },
  { name: 'Roberto A.', city: 'Guadalajara, MX', pack: 'Megapack Premium', minutesAgo: 17 },
  { name: 'Patricia V.', city: 'Medellín, CO', pack: 'Pack Base', minutesAgo: 21 },
  { name: 'Héctor S.', city: 'Quito, EC', pack: 'Megapack Premium', minutesAgo: 24 },
  { name: 'Gabriela T.', city: 'Montevideo, UY', pack: 'Pack Base', minutesAgo: 27 },
  { name: 'Miguel C.', city: 'Monterrey, MX', pack: 'Megapack Premium', minutesAgo: 31 },
  { name: 'Lucía F.', city: 'San José, CR', pack: 'Megapack Premium', minutesAgo: 35 },
  { name: 'Ana B.', city: 'Guayaquil, EC', pack: 'Pack Base', minutesAgo: 39 },
  { name: 'Osvaldo D.', city: 'Asunción, PY', pack: 'Megapack Premium', minutesAgo: 43 },
  { name: 'Norma E.', city: 'Ciudad de Panamá, PA', pack: 'Pack Base', minutesAgo: 47 },
  { name: 'Fernando H.', city: 'Santo Domingo, DO', pack: 'Megapack Premium', minutesAgo: 52 },
  { name: 'Carlos V.', city: 'Guatemala, GT', pack: 'Megapack Premium', minutesAgo: 56 },
  { name: 'Rosa M.', city: 'Córdoba, AR', pack: 'Pack Base', minutesAgo: 61 },
  { name: 'Julio N.', city: 'La Paz, BO', pack: 'Megapack Premium', minutesAgo: 66 },
]
